import dayjs from '../components/libs/dayjs'
// import customParseFormat from 'dayjs/plugin/customParseFormat'
// dayjs.extend(customParseFormat)

export default function formatDate(date, format='MM/DD/YYYY', fallback='None'){
	if(date && date !== '' && (!Array.isArray(date) || date.length > 0)) {
		if(date == '0000-00-00'){
			return fallback;
		}
		else if(date == '0000-00-00'){
			return fallback;
		}
		else {
			let return_date = dayjs(date).format(format);
			return return_date == '12/31/1969' ? fallback : return_date;
		}
	}
	else{
		return '';
	}
}

export function formatDateTime(date, format='M/D/YYYY H:mm', fallback='None') {
	if(date && date !== '' && (!Array.isArray(date) || date.length > 0)) {
		if(date == '0000-00-00' || date == '0000-00-00 00:00'){
			return fallback;
		}
		else {
			let return_date = dayjs(date).format(format);
			return return_date == '12/31/1969' ? fallback : return_date;
		}
	}
	else{
		return '';
	}
}
